import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.4 8.273a1.833 1.833 0 0 0-1.855 1.825V14h-.363V6.116a1.833 1.833 0 0 0-1.854-1.825c-.988.018-1.783.812-1.783 1.79V14h-.363V4.37a1.833 1.833 0 0 0-1.854-1.824c-.988.018-1.783.812-1.783 1.79V14h-.363V6.16a1.833 1.833 0 0 0-1.854-1.824c-.988.018-1.783.812-1.783 1.789v10.56l-1.438-1.948a1.837 1.837 0 0 0-2.54-.395 1.77 1.77 0 0 0-.401 2.5l5.71 7.728c.202.274.467.497.774.65.306.154.646.235.99.235h8.981a2.175 2.175 0 0 0 2.124-1.656l1.205-5.041a8.5 8.5 0 0 0 .232-1.968v-6.727c0-.977-.795-1.771-1.783-1.79"
    }, null, -1)
  ])))
}
export default { render: render }